<div [style.visibility]="(stateSvc.checkedReconnection$ | async) ? 'visible' : 'hidden'">
@if (delegatedWalletAnnouncement$ | async; as delegatedWallet) {
  <div class="delegated-wallet-banner">
    You're currently working with a delegated wallet on behalf of
    <a [routerLink]="['/user', delegatedWallet.fullAddress]">{{ delegatedWallet.shortAddress }}</a>
  </div>
}
<app-header />
  <app-side-menu [menuState]="stateSvc.getMenuOpen()" [class.active]="stateSvc.getMenuOpen()" />
<main>
  <router-outlet />
</main>
<app-footer />

<app-approval-modal />
<app-signature-explanation-modal />
<app-mimic-panel />
</div>

<!-- <div
  *ngIf="showInstallPrompt"
  class="add-to-homescreen"
  [class]="promptType">

  <div class="copy">
    <h3>Get Notified</h3>
    <p>{{ installMessage }}</p>
  </div>

  <div class="instruction">
    <div class="left">
      <ng-template [ngTemplateOutlet]="shareIcon"></ng-template>
    </div>

    <p>{{ installInstructions }}</p>
  </div>
  <button (click)="dismissPrompt()">x</button>
</div>


<ng-template #shareIcon>
  <svg height="18" viewBox="0 0 14 18" width="14" xmlns="http://www.w3.org/2000/svg"><g fill="rgba(var(--background), 1)"><path d="m6 0h2v2h-2z"/><path d="m8 2h2v2h-2z"/><path d="m4 2h2v2h-2z"/><path d="m2 4h2v2h-2z"/><path d="m10 4h2v2h-2z"/><path d="m6 6h2v2h-2z"/><path d="m6 4h2v2h-2z"/><path d="m6 2h2v2h-2z"/><path d="m6 8h2v2h-2z"/><path d="m6 10h2v2h-2z"/><path d="m6 12h2v2h-2z"/><path d="m10 8h2v2h-2z"/><path d="m12 8h2v2h-2z"/><path d="m12 10h2v2h-2z"/><path d="m12 12h2v2h-2z"/><path d="m12 14h2v2h-2z"/><path d="m12 16h2v2h-2z"/><path d="m10 16h2v2h-2z"/><path d="m8 16h2v2h-2z"/><path d="m6 16h2v2h-2z"/><path d="m4 16h2v2h-2z"/><path d="m2 16h2v2h-2z"/><path d="m0 16h2v2h-2z"/><path d="m0 14h2v2h-2z"/><path d="m0 12h2v2h-2z"/><path d="m0 10h2v2h-2z"/><path d="m0 8h2v2h-2z"/><path d="m2 8h2v2h-2z"/></g></svg>
</ng-template>

<button *ngIf="standalone" class="reload" (click)="reloadPage()">Reload <svg height="30" viewBox="0 0 24 30" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="rgba(var(--background), 1)" fill-rule="evenodd"><path d="m6 6h3v3h-3z"/><path d="m9 6h3v3h-3z"/><path d="m12 6h3v3h-3z"/><path d="m15 6h3v3h-3z"/><path d="m12 3h3v3h-3z"/><path d="m12 9h3v3h-3z"/><path d="m9 12h3v3h-3z"/><path d="m9 0h3v3h-3z"/><path d="m3 9h3v3h-3z"/><path d="m0 12h3v3h-3z"/><path d="m0 15h3v3h-3z"/><path d="m0 18h3v3h-3z"/><path d="m0 21h3v3h-3z"/><path d="m3 24h3v3h-3z"/><path d="m6 27h3v3h-3z"/><path d="m9 27h3v3h-3z"/><path d="m12 27h3v3h-3z"/><path d="m15 27h3v3h-3z"/><path d="m18 24h3v3h-3z"/><path d="m21 21h3v3h-3z"/><path d="m21 18h3v3h-3z"/><path d="m21 15h3v3h-3z"/><path d="m21 12h3v3h-3z"/></g></svg></button> -->